import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_membership_points_txn_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  card_no: fromDatatype.VarcharDatatypeInterface;
  doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_line_guid: fromDatatype.GuidDataFieldInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_valid_from: fromDatatype.TimestampTzDatatypeInterface;
  date_valid_to: fromDatatype.TimestampTzDatatypeInterface;
  points_type: fromDatatype.VarcharDatatypeInterface;
  points_value: fromDatatype.NumericDatatypeInterface;
  points_balance: fromDatatype.NumericDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  txn_hdr_guid: fromDatatype.GuidDataFieldInterface;
  point_currency_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  client_key: fromDatatype.VrsnDataFieldInterface;
  client_source: fromDatatype.VrsnDataFieldInterface;
  client_value: fromDatatype.VrsnDataFieldInterface;
  point_currency: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  source: fromDatatype.VrsnDataFieldInterface;
  txn_count: fromDatatype.NumericDatatypeInterface;
  ocr_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ocr_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  ctrl_acc_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  display_type: fromDatatype.VarcharDatatypeInterface;
}

export class bl_crm_membership_points_txn_line_RowClass
  implements bl_crm_membership_points_txn_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  card_no: fromDatatype.VarcharDatatypeInterface;
  doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_line_guid: fromDatatype.GuidDataFieldInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_valid_from: fromDatatype.TimestampTzDatatypeInterface;
  date_valid_to: fromDatatype.TimestampTzDatatypeInterface;
  points_type: fromDatatype.VarcharDatatypeInterface;
  points_value: fromDatatype.NumericDatatypeInterface;
  points_balance: fromDatatype.NumericDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  txn_hdr_guid: fromDatatype.GuidDataFieldInterface;
  point_currency_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  client_key: fromDatatype.VrsnDataFieldInterface;
  client_source: fromDatatype.VrsnDataFieldInterface;
  client_value: fromDatatype.VrsnDataFieldInterface;
  point_currency: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  source: fromDatatype.VrsnDataFieldInterface;
  txn_count: fromDatatype.NumericDatatypeInterface;
  ocr_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ocr_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  ctrl_acc_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  display_type: fromDatatype.VarcharDatatypeInterface;
}
